import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'morva-error-uploading-data-source-modal',
  templateUrl: './error-uploading-data-source-modal.component.html',
  styleUrls: ['./error-uploading-data-source-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorUploadingDataSourceModalComponent implements OnInit {

  constructor(private dialogRef: NbDialogRef<any>) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }

}
